export default function SvgPointsHorizontal2() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        x="0"
        y="0"
        enableBackground="new 0 0 283.535 283.535"
        version="1.1"
        viewBox="0 0 283.535 283.535"
        xmlSpace="preserve"
      >
        <path d="M40.687 101.082C18.252 101.082 0 119.333 0 141.768s18.252 40.686 40.687 40.686 40.686-18.251 40.686-40.686-18.252-40.686-40.686-40.686zm0 63.371c-12.51 0-22.687-10.177-22.687-22.686s10.177-22.686 22.687-22.686c12.509 0 22.686 10.177 22.686 22.686s-10.178 22.686-22.686 22.686zM141.768 101.082c-22.435 0-40.686 18.251-40.686 40.686s18.251 40.686 40.686 40.686 40.686-18.251 40.686-40.686-18.252-40.686-40.686-40.686zm0 63.371c-12.509 0-22.686-10.177-22.686-22.686s10.177-22.686 22.686-22.686 22.686 10.177 22.686 22.686-10.178 22.686-22.686 22.686zM242.849 101.082c-22.435 0-40.686 18.251-40.686 40.686s18.251 40.686 40.686 40.686 40.687-18.251 40.687-40.686-18.253-40.686-40.687-40.686zm0 63.371c-12.509 0-22.686-10.177-22.686-22.686s10.177-22.686 22.686-22.686c12.51 0 22.687 10.177 22.687 22.686s-10.178 22.686-22.687 22.686z"></path>
      </svg>
    </>
  );
}
